import { Control, Controller } from 'react-hook-form'

import { TextField } from '@mui/material'

import { VideoMainFormValues } from '../../videoMainForm.types'

type Props = {
  control: Control<VideoMainFormValues>
}

export const CodeController = ({ control }: Props) => {
  return (
    <Controller
      control={control}
      defaultValue={''}
      name={'code'}
      render={({ field }) => <TextField fullWidth label={'Session code'} {...field} />}
    />
  )
}
